import gsap from 'gsap'

export default class Art {
	constructor() {
		this.artListingContainer = document.querySelector('[data-artlistings-container]')

		if (!this.artListingContainer) return

		this.imageContainer = document.querySelector('[data-art-mouse]')

		if (!this.imageContainer) return

		this.imageTrack = this.imageContainer.querySelector(':scope > div')

		if (!this.imageTrack) return

		this.teases = document.querySelectorAll('[data-tease-art]')

		if (!this.teases.length) return

		this.teaseContainer = document.querySelector('[data-tease-art-container]')

		this.#init()
	}

	#init() {
		this.#initMouseFollower()
		this.#initImageScroll()
		this.#initHoverScale()
	}

	#initMouseFollower() {
		const ease = 'expo.out'
		const duration = 1.1

		const yTo = gsap.quickTo(this.imageContainer, 'y', { duration, ease })

		this.#measureBounds()

		this.lastClientY = null

		this.updateFollower = () => {
			if (this.lastClientY == null) return
			const rawY = this.lastClientY - this.containerRect.top
			const clampedY = Math.max(this.teaseTop, Math.min(this.teaseBottom, rawY))
			yTo(clampedY)
		}

		this.onResize = () => {
			this.#measureBounds()
			this.updateFollower()
		}

		this.onMouseMove = e => {
			this.lastClientY = e.clientY
			this.updateFollower()
		}

		this.artListingContainer.addEventListener('mousemove', this.onMouseMove)
		window.addEventListener('resize', this.onResize)
		window.addEventListener('scroll', this.onResize, { passive: true })
	}

	#measureBounds() {
		this.containerRect = this.artListingContainer.getBoundingClientRect()

		if (this.teaseContainer) {
			const teaseRect = this.teaseContainer.getBoundingClientRect()
			this.teaseTop = teaseRect.top - this.containerRect.top
			this.teaseBottom = teaseRect.bottom - this.containerRect.top
		} else {
			this.teaseTop = -Infinity
			this.teaseBottom = Infinity
		}
	}

	#initImageScroll() {
		const firstImage = this.imageTrack.querySelector('img')
		this.itemHeight = firstImage ? firstImage.offsetHeight : this.imageContainer.offsetHeight

		gsap.set(this.imageTrack, { transformOrigin: 'top center' })

		this.yTo = gsap.quickTo(this.imageTrack, 'y', { duration: 1.1, ease: 'expo.out' })

		this.teaseHandlers = []

		this.teases.forEach((tease, index) => {
			const handler = () => this.yTo(-index * this.itemHeight)
			tease.addEventListener('mouseenter', handler)
			this.teaseHandlers.push({ tease, handler })
		})
	}

	#initHoverScale() {
		if (!this.teaseContainer) return

		gsap.set(this.imageContainer, { scale: 0 })
		gsap.set(this.imageTrack, { scale: 1.5 })

		const tweenScale = (target, value) =>
			gsap.to(target, { scale: value, duration: 0.9, ease: 'expo.out', overwrite: 'auto' })

		this.onTeaseEnter = () => {
			tweenScale(this.imageContainer, 1)
			tweenScale(this.imageTrack, 1)
		}

		this.onTeaseLeave = () => {
			tweenScale(this.imageContainer, 0)
			tweenScale(this.imageTrack, 1.5)
		}

		this.teaseContainer.addEventListener('mouseenter', this.onTeaseEnter)
		this.teaseContainer.addEventListener('mouseleave', this.onTeaseLeave)
	}

	destroy() {
		if (this.onMouseMove) {
			this.artListingContainer.removeEventListener('mousemove', this.onMouseMove)
		}

		if (this.onResize) {
			window.removeEventListener('resize', this.onResize)
			window.removeEventListener('scroll', this.onResize)
		}

		if (this.teaseHandlers) {
			this.teaseHandlers.forEach(({ tease, handler }) => {
				tease.removeEventListener('mouseenter', handler)
			})
		}

		if (this.teaseContainer) {
			if (this.onTeaseEnter) this.teaseContainer.removeEventListener('mouseenter', this.onTeaseEnter)
			if (this.onTeaseLeave) this.teaseContainer.removeEventListener('mouseleave', this.onTeaseLeave)
		}
	}
}
